module.exports = __webpack_public_path__ + "img/image-029.b8f22ba6.png";